export default function InputText({ label, placeholder, type, id, className, children, labelStyle, fieldStyle, value,disabled }) {
    return (
        <div className={`flex flex-col gap-1 flex-grow  ${className ? className : ""}`}>
            <label className={labelStyle} htmlFor={id}>{label}{children}</label>
            <input className={fieldStyle} type={type} disabled={disabled} name={id} id={id} placeholder={placeholder} value={value} />
        </div>
    )
}